import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import logoQ from '../../_static/images/logo-q.svg'
import {LOADER_BAR_COLOR, LOADER_BAR_Q_LOADER_MODAL_SCOPE} from "../../settings/constants"
import LoadingBar from 'react-redux-loading-bar'


let QlogoLoader = (props, context) => {
    let {zIndex, loadingText = "Loading..."} = props
    let {formatMessage} = context
    return (
        <Modal
            isOpen = {true}
            style = {{
                overlay : {zIndex},
            }}
            overlayClassName = "custom-modal"
            className = "custom-modal-content create-dialog-modal-content q-logo-loader-create-dialog-modal-content"
        >
            <div className="posr">
                <div className="loader-bar-wrapper-absolute">
                    <LoadingBar style={{backgroundColor: LOADER_BAR_COLOR}} scope={LOADER_BAR_Q_LOADER_MODAL_SCOPE} />
                </div>
            </div>
            <div className="create-dialog-modal-content__body">
                <div className="q-logo-loader">
                    <img src={logoQ} alt=""/>
                </div>
                <p className="text-center">{formatMessage(loadingText)}</p>
            </div>
        </Modal>
    )
}

QlogoLoader.contextTypes = {formatMessage: PropTypes.any}

export default QlogoLoader


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/QlogoLoader.js